import { render, staticRenderFns } from "./VersionTag.vue?vue&type=template&id=7c79345c&scoped=true"
import script from "./VersionTag.vue?vue&type=script&lang=js"
export * from "./VersionTag.vue?vue&type=script&lang=js"
import style0 from "./VersionTag.vue?vue&type=style&index=0&id=7c79345c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c79345c",
  null
  
)

export default component.exports